import * as React from "react";
import {
  Breadcrumb,
  Button,
  Form,
  Row,
  Table,
  Input,
  Checkbox,
  Col,
  FormInstance,
  Modal,
  message,
  Space,
} from "antd";
import "../css/student.css";
import DataSource, { DeleteRecord } from "../lib/DataSource";
import { CloseCircleOutlined, SendOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import moment from "moment";

const { TextArea } = Input;

export default class FinanceView extends React.Component<
  { id: number },
  {
    student: any;
    records: any;
    student_finance: any;
    loading: boolean;
  }
> {
  contentType = "finance";
  formRef = React.createRef<FormInstance>();
  columns = [
    { title: "ID", dataIndex: "id", key: "id" },
    { title: "Category", dataIndex: "category", key: "category" },
    {
      title: "Date",
      render: (record) => (
        <span>{moment(record.date, moment.ISO_8601).format("DD/MM/YYYY")}</span>
      ),
    },
    { title: "Reference No.", dataIndex: "reference_no", key: "reference_no" },
    {
      title: "Comment",
      render: (record) => (
        <span title={record.comment}>{record.comment.substr(0, 20)}</span>
      ),
    },
    {
      title: "Created",
      render: (record) => (
        <span>
          {moment(record.created, moment.ISO_8601)
            .local()
            .format("YYYY-MM-DD HH:mm:ss")}
        </span>
      ),
    },

    {
      title: "Fee",
      render: (record) => (
        <span>
          {record.payment_type == 1 ? record.amount.toLocaleString() : ""}
        </span>
      ),
    },
    {
      title: "Payment",
      render: (record) => (
        <span>
          {record.payment_type == 1 ? "" : record.amount.toLocaleString()}
        </span>
      ),
    },
    {
      title: "Balance",
      render: (record) => <span>{record.balance.toLocaleString()}</span>,
    },

    {
      title: "Operation",
      render: (record) => (
        <>
          <Link to={"/finance/records/edit/" + record.id}>Edit</Link>
          <Button type="link" onClick={() => this.delete(record)}>
            Delete
          </Button>
        </>
      ),
    },
  ];

  constructor(props) {
    super(props);

    this.state = {
      student: null,
      records: null,
      loading: true,
      student_finance: {},
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.loadStudentData();
    this.loadStudentFinanceRecords();
  }

  delete(record) {
    Modal.confirm({
      content: <p>Confirm to delete record {record.id}?</p>,
      onOk: async () => {
        let result = await DeleteRecord(record.id);
        if (result.ok) {
          this.loadStudentFinanceRecords();
        } else {
          message.error("Error while deleting.");
        }
      },
    });
  }

  loadStudentData() {
    DataSource.loadFinanceData(this.props.id).then((data) => {
      this.setState({ student_finance: data ? data : {}, loading: false });
    });
  }

  loadStudentFinanceRecords() {
    DataSource.loadFinanceRecordsData(this.props.id)
      .then((data) => this.calculateBalance(data))
      .then((data) => {
        this.setState({
          student: data.student,
          records: data.records,
          loading: false,
        });
      });
  }

  handleSubmit(values) {
    let url = "icd/finance/update/" + this.props.id;

    DataSource.submitData(url, {
      ...values,
      is_contract: values.is_contract ? 1 : 0,
    }).then((result) => {
      if (result == 1) {
        Modal.info({ content: "Updated" });
      }
      this.setState({});
    });
  }

  calculateBalance(data) {
    if (!data || !data.records) {
      return data;
    }

    let records = data.records;

    let balance = 0;

    for (let i = records.length - 1; i >= 0; i--) {
      let record = records[i];
      if (record.payment_type == 1) {
        balance += record.amount;
      } else {
        balance -= record.amount;
      }
      data.records[i].balance = balance;
    }
    // records.map((record, index) => {

    //     return record.balance = balance;
    // });

    return data;
  }

  render() {
    let loading = this.state.loading;
    let student = this.state.student;
    let student_finance = this.state.student_finance;
    let records = this.state.records;

    if (student == null) {
      return <div>Loading...</div>;
    }

    return (
      <div>
        <h2>
          Records of {student.firstname} {student.lastname}({student.student_no}
          )
        </h2>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/finance/list">Finance</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Records</Breadcrumb.Item>
        </Breadcrumb>
        <div style={{ textAlign: "right" }}>
          <Link to={"/finance/records/" + this.props.id + "/add"}>
            <Button type="primary">Add Record</Button>
          </Link>
          <br />
          <br />
        </div>
        <Table
          columns={this.columns}
          dataSource={records}
          loading={loading}
          size="small"
          pagination={false}
        ></Table>
        <Form
          style={{ paddingBottom: 50 }}
          name={this.contentType + "-edit"}
          ref={this.formRef}
          onFinish={this.handleSubmit.bind(this)}
          initialValues={student}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                name="is_contract"
                valuePropName="checked"
                initialValue={student_finance.is_contract == 1}
              >
                <Checkbox>Is Contract</Checkbox>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Note" name="note">
                <TextArea rows={4} defaultValue={student_finance.note} />
              </Form.Item>
            </Col>
          </Row>

          <Space>
            <Button type="primary" icon={<SendOutlined />} htmlType="submit">
              Submit
            </Button>
            <a href="javascript:history.go(-1)">
              <CloseCircleOutlined /> Back
            </a>
          </Space>
        </Form>
      </div>
    );
  }
}
